import React from 'react';

function Footer() {
  const version = process.env.REACT_APP_VERSION || '0.0.0';
  const gitSha = process.env.REACT_APP_GIT_SHA || 'dev';
  const buildNumber = process.env.REACT_APP_BUILD_NUMBER;
  const buildTime = process.env.REACT_APP_BUILD_TIME;

  const buildTimeLabel = buildTime
    ? new Date(buildTime).toLocaleString()
    : 'local (unbuilt)';

  return (
    <footer className="app-footer">
      <span>v{version} ({gitSha}{buildNumber && buildNumber !== 'local' ? `, build #${buildNumber}` : ''})</span>
      <span className="app-footer-separator">•</span>
      <span>Built {buildTimeLabel}</span>
    </footer>
  );
}

export default Footer;
